<script setup>
  import { defineEmits, ref, nextTick, watch, computed } from 'vue';
  const emits = defineEmits();

  const props = defineProps({
    show: {
      type: Boolean,
      required: true
    },
    withOutTitle: {
      type: Boolean,
      default: false,
      required: false
    },
    size: {
      type: String,
      default: 'small',
      required: false
    },
    dismissible: {
      type: Boolean,
      default: true,
      required: false
    }
  });

  const currentModal = ref(null);

  const closeModal = () => {
    emits('close')
  }

  const handleDismissAttempt = () => {
    if (props.dismissible) closeModal();
  }

  const sizeClass = computed(() => {
    if (props.size === 'large') {
      return 'modal-xl';
    } else if (props.size === 'medium') {
      return 'modal-lg';
    } else {
      return '';
    }
  });

  watch(() => props.show, async (newValue) => {
    if (newValue) {
      await nextTick();
      currentModal.value.focus();
    }
  });
</script>

<template>
  <div ref="currentModal" :class="`modal ${show ? 'show' : ''} fade`" tabindex="-1" v-if="show" :style="{ display: (show ? 'block' : 'none') }" role="dialog" @click.self="handleDismissAttempt" @keydown.esc="handleDismissAttempt" aria-labelledby="modalTitle">
    <div :class="`modal-dialog modal-dialog-centered ${sizeClass}`">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="modalTitle" class="modal-title" v-if="!withOutTitle">
            <slot name="title"></slot>
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <slot>
            <div class="loader hidden"></div>
          </slot>
        </div>
        <div class="modal-footer" v-if="$slots.footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .modal {
    background-color: rgba(0, 0, 0, 0.5);
  }
</style>
